/* eslint-disable */
import {
	Box,
	Flex,
	Table,
	Tbody,
	Td,
	Text,
	Th,
	Thead,
	Tr,
	Button,
	Input,
	InputGroup,
	InputLeftElement,
	Select,
	Icon,
	HStack,
	useColorModeValue,
	Popover,
	PopoverTrigger,
	PopoverContent,
	PopoverArrow,
	PopoverCloseButton,
	PopoverHeader,
	PopoverBody,
	useDisclosure,
	Badge,
	useToast,
	Modal,
	ModalOverlay,
	ModalContent,
	ModalHeader,
	ModalFooter,
	ModalBody,
	ModalCloseButton,
	Alert,
	AlertIcon,
	List,
	ListItem,
	ListIcon,
	Divider,
	Textarea,
	Image,
	FormControl,
	FormLabel,
	IconButton,
	VisuallyHidden,
	Stack
} from '@chakra-ui/react';
import { useNavigate } from "react-router-dom";
import { MdCheckCircle, MdWarning } from 'react-icons/md';
import {
	createColumnHelper,
	flexRender,
	getCoreRowModel,
	getSortedRowModel,
	SortingState,
	useReactTable,
} from '@tanstack/react-table';
import React, { useEffect, useState, useRef } from 'react';
import Card from 'components/card/Card';
import resguardosApi from 'api/resguardos';
import { AddIcon, DeleteIcon, SearchIcon } from '@chakra-ui/icons';
type ActivoRaw = {
	HotelId: number;
	DepartamentoId: number;
	Id: number;
	Folio: string;
	ActiveName: string;
	PermitidoSalir: boolean;
	SerialNumber: string;
	Precio: number;
	Garantia: string;
	CreatedDate: string;
	LastModifiedDate: string;
	LastLogin: string;
	Departamento: string;
	Proveedor: string;
	Modelo: string;
	Subfamilia: string;
	tbaSublinea?: string;
	Estado: string;
	QR: string;
	Hotel: string;
	UsuariosId: number;
	activoDueno: string;
	NumControl?: string;
};

type RowObj = {
	idActivo?: number;
	item: string[];
	DepartamentoId?: number;
	quantity: number;
	rate: number;
	amount: number;
	status: string;
	UsuariosId: number;
	activoDueno: string;
	NumControl?: string;
	serialNumber?: string; // ← Agregar esta propiedad
	Folio: string;
	categoria?: string;
};

type ActivoNotas = {
	idActivo: number;
	notas: string;
	fotos: string[]; // URLs base64 de las fotos
};

// Un resguardo debe ser de un solo hotel (ver insertResguardo): se acota al
// hotel elegido en el nav, no a todos los hoteles del usuario — si no, se
// podrían elegir activos de un hotel y de otro para el mismo resguardo, y el
// backend lo rechazaría hasta al guardar en vez de no ofrecerlos desde aquí.
const resolverHotelSeleccionadoId = async (): Promise<number | null> => {
	try {
		const hoteles = await fetch('https://inventariosbackend.velasresorts.com/inventarios/hoteles/listado').then(r => r.json());
		const lista = Array.isArray(hoteles) ? hoteles : [];
		const abrev = sessionStorage.getItem('hotelSeleccionado') || '';
		return lista.find((h: any) => h.Abrev === abrev)?.Id ?? null;
	} catch {
		return null;
	}
};

const fetchActivosList = async (): Promise<ActivoRaw[]> => {
	try {
		const user = JSON.parse(sessionStorage.getItem('user') || '{}');
		const todosMisHotelIds = String(user.HotelIds || '')
			.split(',')
			.map((s: string) => Number(s.trim()))
			.filter((n: number) => !isNaN(n));

		const hotelSeleccionadoId = await resolverHotelSeleccionadoId();
		// Si hay un hotel elegido en el nav, solo ese; si no, se cae a todos los
		// hoteles asignados al usuario (comportamiento de siempre).
		const hotelIdsPermitidos = hotelSeleccionadoId != null ? [hotelSeleccionadoId] : todosMisHotelIds;

		const response = await fetch('https://inventariosbackend.velasresorts.com/inventarios/activos/listado');
		if (!response.ok) {
			throw new Error('Error al obtener los activos');
		}
		const data = await response.json();

		return data[0].filter((activo: ActivoRaw) =>
			hotelIdsPermitidos.length === 0 || hotelIdsPermitidos.includes(activo.HotelId)
		);
	} catch (error) {
		console.error('Error fetching activos:', error);
		return [];
	}
};



const columnHelper = createColumnHelper<RowObj>();

interface JefeSignaturePadProps {
	onSave: (signature: string) => void;
	initialSignature?: string;
}

/* const JefeSignaturePad: React.FC<JefeSignaturePadProps> = ({ onSave, initialSignature }) => {
	const canvasRef = useRef<HTMLCanvasElement>(null);
	const [isDrawing, setIsDrawing] = useState(false);
	const [lastPos, setLastPos] = useState({ x: 0, y: 0 });
	const [isAutoLoaded, setIsAutoLoaded] = useState(false);

	// Cargar la firma inicial si existe
/* 	useEffect(() => {
		if (initialSignature && canvasRef.current) {
			const canvas = canvasRef.current;
			const ctx = canvas.getContext('2d');
			if (ctx) {
				const img = new window.Image();
				img.onload = () => {
					ctx.clearRect(0, 0, canvas.width, canvas.height);
					ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
					setIsAutoLoaded(true); // Marcar que la firma fue cargada automáticamente
				};
				img.src = initialSignature;
			}
		}
	}, [initialSignature]);

	const startDrawing = (e: MouseEvent | TouchEvent) => {
		if (!canvasRef.current) return;

		const canvas = canvasRef.current;
		const rect = canvas.getBoundingClientRect();
		const clientX = 'touches' in e ? e.touches[0].clientX : (e as MouseEvent).clientX;
		const clientY = 'touches' in e ? e.touches[0].clientY : (e as MouseEvent).clientY;
		const x = clientX - rect.left;
		const y = clientY - rect.top;

		setIsDrawing(true);
		setLastPos({ x, y });
	};

	const draw = (e: MouseEvent | TouchEvent) => {
		if (!isDrawing || !canvasRef.current) return;

		const canvas = canvasRef.current;
		const ctx = canvas.getContext('2d');
		if (!ctx) return;

		const rect = canvas.getBoundingClientRect();
		const clientX = 'touches' in e ? e.touches[0].clientX : (e as MouseEvent).clientX;
		const clientY = 'touches' in e ? e.touches[0].clientY : (e as MouseEvent).clientY;
		const x = clientX - rect.left;
		const y = clientY - rect.top;

		ctx.strokeStyle = '#000';
		ctx.lineWidth = 2;
		ctx.lineCap = 'round';
		ctx.beginPath();
		ctx.moveTo(lastPos.x, lastPos.y);
		ctx.lineTo(x, y);
		ctx.stroke();

		setLastPos({ x, y });
	};

	const endDrawing = () => {
		setIsDrawing(false);
	};

	const handleClear = () => {
		if (!canvasRef.current) return;
		const canvas = canvasRef.current;
		const ctx = canvas.getContext('2d');
		if (ctx) {
			ctx.clearRect(0, 0, canvas.width, canvas.height);
		}
	};

	const handleSave = () => {
		if (!canvasRef.current) return;
		const canvas = canvasRef.current;
		const ctx = canvas.getContext('2d');
		if (!ctx) return;

		const pixelData = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
		const hasSignature = pixelData.some((channel: number) => channel !== 0);

		if (!hasSignature) {
			return;
		}

		const signatureData = canvas.toDataURL('image/png');
		onSave(signatureData);
	};

	useEffect(() => {
		const canvas = canvasRef.current;
		if (canvas) {
			canvas.width = canvas.offsetWidth;
			canvas.height = canvas.offsetHeight;
		}
	}, []);

	return (
		<Box
			border="1px dashed"
			borderColor={isAutoLoaded ? "green.300" : "gray.300"}
			p={4}
			borderRadius="md"
			mb={4}
			position="relative"
		>
			{isAutoLoaded && (
				<Badge
					colorScheme="green"
					position="absolute"
					top={-2}
					right={-2}
				>
					Firma precargada
				</Badge>
			)}

			<Text fontWeight="bold" mb={2}>Firma del generador del resguardo</Text>
			<Box
				as="canvas"
				ref={canvasRef}
				width="100%"
				height="150px"
				border="1px solid"
				scale="0.8"
				borderColor={isAutoLoaded ? "green.200" : "gray.200"}
				bg="white"
				onMouseDown={isAutoLoaded ? undefined : (startDrawing as any)}
				onMouseMove={isAutoLoaded ? undefined : (draw as any)}
				onMouseUp={endDrawing}
				onMouseLeave={endDrawing}
				onTouchStart={isAutoLoaded ? undefined : (startDrawing as any)}
				onTouchMove={isAutoLoaded ? undefined : (draw as any)}
				onTouchEnd={endDrawing}
				style={{ touchAction: 'none' }}
			/>

			{!isAutoLoaded && (
				<Flex mt={2} gap={2}>
					<Button size="sm" onClick={handleClear}>Limpiar</Button>
					<Button size="sm" colorScheme="blue" onClick={handleSave}>Guardar Firma</Button>
				</Flex>
			)}
		</Box>
	); 
};
 */
export default function InvoiceTable(props: { tableData: RowObj[] }) {
	const toast = useToast();
	const navigate = useNavigate();

	const { tableData } = props;
	const [sorting, setSorting] = React.useState<SortingState>([]);
	const [data, setData] = React.useState<RowObj[]>([]);
	const [availableAssets, setAvailableAssets] = useState<RowObj[]>([]);
	const [searchTerm, setSearchTerm] = React.useState('');
	const [filtroEstadoActivo, setFiltroEstadoActivo] = React.useState<'todos' | 'active' | 'bodega'>('todos');
	const [filtroCategoria, setFiltroCategoria] = React.useState('');
	const { onClose } = useDisclosure();
	const [isReadOnly, setIsReadOnly] = useState(false);
	const { isOpen: isConfirmOpen, onOpen: onConfirmOpen, onClose: onConfirmClose } = useDisclosure();
	const [activeToUnassign, setActiveToUnassign] = useState<RowObj | null>(null);
	const [eventoSinResguardo, setEventoSinResguardo] = useState(false);
	const [isSaveModalOpen, setIsSaveModalOpen] = useState(false);
	const [emailMessage, setEmailMessage] = useState('Se le adjunta el comprobante de resguardo con los siguientes activos:');
	const [apiPayload, setApiPayload] = useState('');
	const [isSending, setIsSending] = useState(false);
	const [jefeFirma, setJefeFirma] = useState('');

	// Nuevos estados para notas y fotos
	const [notasActivos, setNotasActivos] = useState<ActivoNotas[]>([]);
	const fileInputRefs = useRef<{ [key: number]: HTMLInputElement | null }>({});
	// Efecto para inicializar notas cuando se agregan activos
	useEffect(() => {
		const nuevasNotas = data
			.filter(activo => !notasActivos.some(na => na.idActivo === activo.idActivo))
			.map(activo => ({
				idActivo: activo.idActivo!,
				notas: '',
				fotos: [] as string[] // ← Aquí está la corrección
			}));

		if (nuevasNotas.length > 0) {
			setNotasActivos(prev => [...prev, ...nuevasNotas]);
		}
	}, [data]);

	// Función para actualizar notas
	const handleNotasChange = (idActivo: number, notas: string) => {
		setNotasActivos(prev =>
			prev.map(item =>
				item.idActivo === idActivo ? { ...item, notas } : item
			)
		);
	};

	// Función para manejar subida de fotos
	const handleFotoUpload = (idActivo: number, event: React.ChangeEvent<HTMLInputElement>) => {
		const files = event.target.files;
		if (!files || files.length === 0) return;

		const file = files[0];
		const reader = new FileReader();

		reader.onload = (e) => {
			const fotoData = e.target?.result as string;
			setNotasActivos(prev =>
				prev.map(item =>
					item.idActivo === idActivo
						? { ...item, fotos: [...item.fotos, fotoData] }
						: item
				)
			);
		};

		reader.readAsDataURL(file);
		// Limpiar input para permitir subir la misma imagen otra vez
		event.target.value = '';
	};

	// Función para eliminar foto
	const handleRemoveFoto = (idActivo: number, index: number) => {
		setNotasActivos(prev =>
			prev.map(item =>
				item.idActivo === idActivo
					? { ...item, fotos: item.fotos.filter((_, i) => i !== index) }
					: item
			)
		);
	};

	// Obtener usuario y firma del sessionStorage
	const user = JSON.parse(sessionStorage.getItem('user') || '{}');
	const userSignature = user.Firma || '';

	// Cargar firma automáticamente si existe
	useEffect(() => {
		if (userSignature) {
			setJefeFirma(userSignature);
		}
	}, [userSignature]);

	React.useEffect(() => {
		localStorage.removeItem('activosSeleccionados');
	}, []);

	useEffect(() => {
		const loadActivos = async () => {
			const dataObj = await fetchActivosList();
			const renamedArray: RowObj[] = dataObj
				// "active" = disponible normal; "bodega" = disponible mientras no
				// se le busque un destino — ambos son elegibles para un resguardo.
				.filter((obj: ActivoRaw) => obj.Estado === 'active' || obj.Estado === 'bodega')
				.map((obj: ActivoRaw) => ({
					idActivo: obj.Id,
					item: [obj.ActiveName, obj.Modelo || ''],
					DepartamentoId: obj.DepartamentoId,
					quantity: 1,
					rate: obj.Precio,
					amount: obj.Precio,
					status: obj.Estado || 'No dato',
					UsuariosId: obj.UsuariosId,
					activoDueno: obj.activoDueno,
					NumControl: obj.NumControl || 'No dato',
					serialNumber: obj.SerialNumber || 'Sin número de serie', // ← Agregar aquí
					Folio: obj.Folio || 'Sin número de serie', // ← Agregar aquí
					categoria: obj.tbaSublinea || undefined,
				}));

			setAvailableAssets(renamedArray);
		};
		loadActivos();
	}, []);
	useEffect(() => {
		if (data.length > 0) {
			localStorage.setItem('activosSeleccionados', JSON.stringify(data));
		}
	}, [data]);

	const terminoBusqueda = searchTerm.trim().toLowerCase();

	// Categorías (Sublínea) presentes entre los activos disponibles, para el
	// filtro — solo se ofrecen las que de verdad existen en este hotel, no el
	// catálogo completo del sistema.
	const categoriasDisponibles = Array.from(
		new Set(availableAssets.map((item) => item.categoria).filter(Boolean))
	).sort() as string[];

	const filteredAvailableAssets = availableAssets
		.filter((item) =>
			!terminoBusqueda ||
			item.Folio.toLowerCase().includes(terminoBusqueda) ||
			item.serialNumber.toLowerCase().includes(terminoBusqueda) ||
			item.item.some((valor) => (valor || '').toLowerCase().includes(terminoBusqueda))
		)
		.filter((item) => filtroEstadoActivo === 'todos' || item.status === filtroEstadoActivo)
		.filter((item) => !filtroCategoria || item.categoria === filtroCategoria)
		.filter((item) => !data.some((d) => d.idActivo === item.idActivo));

	const columns = [
		columnHelper.accessor('item', {
			id: 'item',
			header: () => (
				<Text justifyContent="space-between" align="center" fontSize={{ sm: '10px', lg: '14px' }} color="gray.400">
					ACTIVO
				</Text>
			),
			cell: (info) => (
				<Flex direction="column">
					<Text color={useColorModeValue('navy.700', 'white')} fontSize="md" fontWeight="700">
						{info.getValue()[0]}
					</Text>
					<Text color={useColorModeValue('secondaryGray.600', 'gray.400')} fontSize="md" fontWeight="400">
						{info.getValue()[1]}
					</Text>
				</Flex>
			),
		}),
		columnHelper.accessor('serialNumber', {
			id: 'serialNumber',
			header: () => (
				<Text justifyContent="space-between" align="center" fontSize={{ sm: '10px', lg: '14px' }} color="gray.400">
					NUM. SERIE
				</Text>
			),
			cell: (info) => (
				<Text color={useColorModeValue('navy.700', 'white')} fontSize="md" fontWeight="500">
					{info.getValue()}
				</Text>
			),
		}),
		columnHelper.accessor('rate', {
			id: 'rate',
			header: () => (
				<Text justifyContent="space-between" align="center" fontSize={{ sm: '10px', lg: '14px' }} color="gray.400">
					PRECIO
				</Text>
			),
			cell: (info) => (
				<Text color={useColorModeValue('navy.700', 'white')} fontSize="md" fontWeight="500">
					${info.getValue()}
				</Text>
			),
		}),
		columnHelper.accessor('amount', {
			id: 'amount',
			header: () => (
				<Text justifyContent="space-between" align="center" fontSize={{ sm: '10px', lg: '14px' }} color="gray.400">
					TOTAL
				</Text>
			),
			cell: (info) => (
				<Text color={useColorModeValue('navy.700', 'white')} fontSize="md" fontWeight="500">
					${info.getValue()}
				</Text>
			),
		}),
	];

	const table = useReactTable({
		data,
		columns,
		state: { sorting },
		onSortingChange: setSorting,
		getCoreRowModel: getCoreRowModel(),
		getSortedRowModel: getSortedRowModel(),
		debugTable: false,
	});

	const handleSelectItem = (item: RowObj) => {
		if (isReadOnly) return;
		if (!data.some((d) => d.idActivo === item.idActivo)) {
			setData((prev) => [...prev, item]);
		}
		setSearchTerm('');
		onClose();
	};
	const handleDeleteItem = (item: RowObj) => {
		setData((prev) => prev.filter((d) => d.idActivo !== item.idActivo));
	};

	const handleSaveConfirmation = () => {
		if (data.length === 0) {
			toast({
				title: 'No hay activos seleccionados',
				description: 'Por favor, selecciona al menos un activo para guardar',
				status: 'warning',
				duration: 3000,
				isClosable: true,
			});
			return;
		}
		setIsSaveModalOpen(true);
	};

	const handleSaveResguardo = async () => {
		if (!jefeFirma) {
			toast({
				title: 'Firma requerida',
				description: 'El jefe de área debe firmar el resguardo',
				status: 'warning',
				duration: 3000,
				isClosable: true,
			});
			return;
		}

		setIsSending(true);

		const user = JSON.parse(sessionStorage.getItem('user') || '{}')

		try {
			const firmaColaborador = sessionStorage.getItem('firma');
			const colaborador = sessionStorage.getItem('colaborador') || '';

			// PRIMERO: Enviar el resguardo normal (como ya estaba)
			const resguardoResponse = await resguardosApi.crear({
				activos: data.map(activo => {
					const notasYFotos = notasActivos.find(na => na.idActivo === activo.idActivo);
					return {
						...activo,
						notas: notasYFotos?.notas || '',
					};
				}),
				colaborador,
				firma: firmaColaborador,
				firmaJefe: jefeFirma,
				estado: 'Borrador',
				usuarioCreadorId: user.Id
			});

			console.log('Resguardo creado:', resguardoResponse);

			// SEGUNDO: Si hay fotos, enviarlas por separado
			if (notasActivos.some(na => na.fotos.length > 0)) {
				const formData = new FormData();
				formData.append('resguardoId', resguardoResponse.Id);
				formData.append('colaborador', colaborador);

				// Todas las notas bajo la misma clave "activo" como un arreglo
				const notasPorActivo = {
					activo: notasActivos.map(na => na.notas || '')
				};
				formData.append('notas', JSON.stringify(notasPorActivo));

				// Función para convertir base64 a Blob
				const base64ToBlob = (base64: string): Blob => {
					const parts = base64.split(';base64,');
					const contentType = parts[0].split(':')[1];
					const raw = window.atob(parts[1]);
					const uInt8Array = new Uint8Array(raw.length);
					for (let i = 0; i < raw.length; ++i) uInt8Array[i] = raw.charCodeAt(i);
					return new Blob([uInt8Array], { type: contentType });
				};

				// Agregar todas las fotos, la clave en FormData puede repetirse
				notasActivos.forEach(notaActivo => {
					notaActivo.fotos.forEach(foto => {
						if (foto) {
							const blob = base64ToBlob(foto);
							formData.append('fotos', blob, 'activo.jpg'); // mismo nombre está bien en FormData
						}
					});
				});

				// Enviar fotos y notas
				await fetch('https://inventariosbackend.velasresorts.com/inventarios/resguardos/agregar-fotos', {
					method: 'POST',
					body: formData,
				});
			}



			toast({
				title: 'Resguardo guardado',
				description: 'Los activos han sido guardados correctamente.',
				status: 'success',
				duration: 1000,
				isClosable: true,
			});

			sessionStorage.setItem('sign', '0');
			setData([]);
			setNotasActivos([]);
			setJefeFirma('');
			setIsSaveModalOpen(false);

			setTimeout(() => {
				navigate('/admin/main/ecommerce/referrals')
			}, 3000);

		} catch (error) {
			console.error('Error al guardar resguardo:', error);
			toast({
				title: 'Error',
				description: 'Ocurrió un error al guardar el resguardo',
				status: 'error',
				duration: 3000,
				isClosable: true,
			});
		} finally {
			setIsSending(false);
		}
	};

	const textColor = useColorModeValue('navy.700', 'white');
	const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');

	return (
		<Flex direction="column" w="100%" overflowX={{ sm: 'scroll', lg: 'hidden' }}>
			<Flex justify="flex-end" mb={4} gap={4} align="center">
				{eventoSinResguardo && (
					<Text fontSize="sm" color="red.500">
						No tiene resguardos
					</Text>
				)}
				<Popover placement="right-start" isLazy>
					<PopoverTrigger>
						<Button
							bg="brand.500"
							variant="solid"
							color="white"
							fontWeight="600"
							size="md"
							boxShadow="md"
							_hover={{ bg: 'brand.600' }}
							isDisabled={isReadOnly}
						>
							Agregar nuevo
						</Button>
					</PopoverTrigger>

					<PopoverContent
						w={{ base: '90vw', md: '560px' }}
						maxW="90vw"
						borderRadius="xl"
						boxShadow="xl"
						bg={useColorModeValue('white', 'gray.700')}
						border="1px solid"
						borderColor={useColorModeValue('gray.200', 'gray.600')}
					>
						<PopoverArrow bg={useColorModeValue('white', 'gray.700')} />
						<PopoverCloseButton />
						<PopoverHeader
							borderBottom="1px solid"
							borderColor={useColorModeValue('gray.200', 'gray.600')}
							borderTopRadius="xl"
							px={4}
							py={4}
							pr={10}
						>
							<Flex align="center" gap={3}>
								<Flex
									align="center"
									justify="center"
									boxSize={8}
									borderRadius="full"
									bg={useColorModeValue('teal.50', 'teal.800')}
									flexShrink={0}
								>
									<Icon as={SearchIcon} color="teal.400" boxSize={3.5} />
								</Flex>
								<Text fontWeight="bold" fontSize="lg" color={useColorModeValue('teal.800', 'teal.300')}>
									Agregar activo al resguardo
								</Text>
							</Flex>
						</PopoverHeader>
						<PopoverBody p={4}>
							<InputGroup mb={4}>
								<InputLeftElement pointerEvents="none">
									<SearchIcon color="gray.400" boxSize={3.5} />
								</InputLeftElement>
								<Input
									placeholder="Buscar por nombre, modelo, folio o número de serie..."
									value={searchTerm}
									onChange={(e) => setSearchTerm(e.target.value)}
									size="md"
									borderRadius="md"
									focusBorderColor="teal.400"
									boxShadow="sm"
									autoFocus
								/>
							</InputGroup>

							<Flex gap={3} mb={4} flexWrap="wrap" align="center">
								<HStack spacing={2}>
									{([
										{ valor: 'todos', label: 'Todos' },
										{ valor: 'active', label: 'Disponible' },
										{ valor: 'bodega', label: 'Bodega' },
									] as const).map((opcion) => (
										<Badge
											key={opcion.valor}
											as="button"
											onClick={() => setFiltroEstadoActivo(opcion.valor)}
											cursor="pointer"
											px={3}
											py={1}
											borderRadius="full"
											fontSize="xs"
											textTransform="none"
											colorScheme={filtroEstadoActivo === opcion.valor ? 'teal' : 'gray'}
											variant={filtroEstadoActivo === opcion.valor ? 'solid' : 'subtle'}
										>
											{opcion.label}
										</Badge>
									))}
								</HStack>

								{categoriasDisponibles.length > 0 && (
									<Select
										size="sm"
										maxW="220px"
										borderRadius="md"
										value={filtroCategoria}
										onChange={(e) => setFiltroCategoria(e.target.value)}
									>
										<option value="">Todas las categorías</option>
										{categoriasDisponibles.map((cat) => (
											<option key={cat} value={cat}>{cat}</option>
										))}
									</Select>
								)}
							</Flex>

							<Text fontSize="xs" color="gray.500" mb={3}>
								{availableAssets.length === 0
									? 'No hay activos disponibles en este hotel.'
									: `${filteredAvailableAssets.length} activo(s) disponible(s)`}
							</Text>

							{availableAssets.length > 0 && filteredAvailableAssets.length === 0 && (
								<Text fontSize="sm" color="gray.500" textAlign="center" mt={4}>
									{terminoBusqueda || filtroCategoria || filtroEstadoActivo !== 'todos'
										? 'No se encontraron resultados con esos filtros.'
										: 'Ya agregaste todos los activos disponibles.'}
								</Text>
							)}

							<Box maxH="420px" overflowY="auto" pr={2}>
								{filteredAvailableAssets.map((record, index) => (
									<Flex
										key={index}
										justify="space-between"
										align="center"
										mb={3}
										p={4}
										border="1px solid"
										borderColor={useColorModeValue('gray.100', 'gray.600')}
										borderRadius="lg"
										_hover={record.status !== 'assigned' ? { bg: useColorModeValue('teal.50', 'teal.800'), cursor: 'pointer' } : undefined}
										transition="background-color 0.2s ease"
										gap={4}
										onClick={record.status !== 'assigned' ? () => handleSelectItem(record) : undefined}
									>
										<Flex direction="column" flex="1" minW={0} gap={1}>
											<Text
												fontSize="md"
												fontWeight="600"
												color={useColorModeValue('teal.700', 'teal.300')}
												isTruncated
												maxW="260px"
											>
												{record.item[0]}
											</Text>
											<Text
												fontSize="sm"
												color={useColorModeValue('gray.600', 'gray.400')}
												isTruncated
												maxW="260px"
											>
												{record.item[1]}
											</Text>

											<Text
												fontSize="md"
												color={useColorModeValue('blue.600', 'blue.300')}
												isTruncated
												maxW="260px"
												fontWeight="500"
											>
												Serie: {record.serialNumber}
											</Text>
											<Text
												fontSize="sm"
												isTruncated
												maxW="260px"
												fontWeight="500"
												bg={useColorModeValue('red.50', 'red.900')}
												color={useColorModeValue('red.700', 'red.200')}
												textAlign="center"
												borderRadius="md"
												px={2}
												py={1}
												mt={1}
												w="fit-content"
											>
												<strong>Folio:</strong> {record.Folio}
											</Text>


											{/* 											<Text
												fontSize="x-small"
												backgroundColor="red.200"
												borderRadius={20}
												color={useColorModeValue('gray.600', 'gray.400')}
												isTruncated
												textAlign="center"
												maxW="260px">
												{record.activoDueno}
											</Text> */}
										</Flex>

										<Badge
											alignSelf="center"
											colorScheme={
												record.status === 'active'
													? 'green'
													: record.status === 'bodega'
														? 'teal'
														: record.status === 'pendiente'
															? 'yellow'
															: record.status === 'inactive'
																? 'red'
																: record.status === 'assigned'
																	? 'blue'
																	: 'gray'
											}
											px={2}
											py={1}
											borderRadius="md"
											fontWeight="bold"
											textTransform="capitalize"
											w="80px"
											textAlign="center"
											flexShrink={0}
										>
											{record.status === 'active' ? 'Disponible' : record.status}
										</Badge>

										<Button
											size="sm"
											colorScheme="teal"
											variant="outline"
											onClick={(e) => { e.stopPropagation(); handleSelectItem(record); }}
											isDisabled={record.status === "assigned"}
											borderRadius="md"
											_hover={{ bg: useColorModeValue('teal.100', 'teal.700') }}
											flexShrink={0}
										>
											+
										</Button>
									</Flex>
								))}
							</Box>
						</PopoverBody>
					</PopoverContent>
				</Popover>

				<Button
					bg="green.500"
					variant="solid"
					color="white"
					fontWeight="600"
					size="md"
					boxShadow="md"
					_hover={{ bg: 'green.600' }}
					onClick={handleSaveConfirmation}
					isDisabled={data.length === 0}
				>
					Guardar
				</Button>
			</Flex>

			<Modal isOpen={isSaveModalOpen} onClose={() => setIsSaveModalOpen(false)} size="xl">
				<ModalOverlay />
				<ModalContent maxH="80vh" overflowY="auto">
					<ModalHeader>Confirmar Resguardo</ModalHeader>
					<ModalCloseButton />
					<ModalBody>
						<Alert status="info" mb={4} borderRadius="md">
							<AlertIcon />
							¿Está seguro que desea realizar este resguardo?
						</Alert>

						<Text mb={4}>
							Se enviará un correo electrónico al responsable con el comprobante y los siguientes activos:
						</Text>

						<Box maxH="200px" overflowY="auto" mb={4} border="1px solid" borderColor="gray.200" borderRadius="md" p={3}>
							<List spacing={3}>
								{data.map((activo, index) => (
									<ListItem key={index}>
										<Flex align="center">
											<ListIcon as={MdCheckCircle} color="green.500" />
											<Box>
												<Text fontWeight="bold">{activo.item[0]}</Text>
												<Text fontSize="sm" color="gray.600">{activo.item[1]}</Text>
											</Box>
										</Flex>
									</ListItem>
								))}
							</List>
						</Box>

						{/* Sección de notas y fotos por activo */}
						<Box mb={4}>
							<Text fontWeight="bold" mb={3}>Detalles de los activos:</Text>
							<Stack spacing={4}>
								{data.map((activo, index) => {
									const notasYFotos = notasActivos.find(na => na.idActivo === activo.idActivo);

									return (
										<Box key={index} p={3} border="1px solid" borderColor="gray.200" borderRadius="md">
											<Text fontWeight="medium" mb={2}>{activo.item[0]}</Text>

											<FormControl mb={3}>
												<FormLabel fontSize="sm">Notas para este activo:</FormLabel>
												<Textarea
													placeholder="Agregar detalles, observaciones o condiciones del activo..."
													value={notasYFotos?.notas || ''}
													onChange={(e) => handleNotasChange(activo.idActivo!, e.target.value)}
													size="sm"
													rows={2}
												/>
											</FormControl>

											<FormControl>
												<FormLabel fontSize="sm">Fotos del activo:</FormLabel>
												<Stack direction="row" spacing={2} mb={2} flexWrap="wrap">
													{notasYFotos?.fotos.map((foto, fotoIndex) => (
														<Box key={fotoIndex} position="relative" display="inline-block">
															<Image
																src={foto}
																alt={`Foto ${fotoIndex + 1} de ${activo.item[0]}`}
																boxSize="60px"
																objectFit="cover"
																borderRadius="md"
																border="1px solid"
																borderColor="gray.200"
															/>
															<IconButton
																icon={<DeleteIcon />}
																size="xs"
																position="absolute"
																top={-2}
																right={-2}
																aria-label="Eliminar foto"
																onClick={() => handleRemoveFoto(activo.idActivo!, fotoIndex)}
																colorScheme="red"
															/>
														</Box>
													))}

													<VisuallyHidden>
														<input
															type="file"
															accept="image/*"
															ref={el => fileInputRefs.current[activo.idActivo!] = el}
															onChange={(e) => handleFotoUpload(activo.idActivo!, e)}
															capture="environment"
														/>
													</VisuallyHidden>

													<IconButton
														icon={<AddIcon />}
														aria-label="Añadir foto"
														onClick={() => fileInputRefs.current[activo.idActivo!]?.click()}
														size="sm"
														variant="outline"
													/>
												</Stack>
											</FormControl>
										</Box>
									);
								})}
							</Stack>
						</Box>

					</ModalBody>
					<ModalFooter>
						<Button variant="outline" mr={3} onClick={() => setIsSaveModalOpen(false)}>
							Cancelar
						</Button>
						<Button
							colorScheme="green"
							onClick={handleSaveResguardo}
							isLoading={isSending}
							loadingText="Enviando..."
						>
							Confirmar y Enviar
						</Button>
					</ModalFooter>
				</ModalContent>
			</Modal>

			<Box>
				<Table variant="simple" color="gray.500">
					<Thead>
						{table.getHeaderGroups().map((headerGroup) => (
							<Tr key={headerGroup.id}>
								{headerGroup.headers.map((header) => (
									<Th
										key={header.id}
										colSpan={header.colSpan}
										pe="10px"
										borderColor={borderColor}
										cursor="pointer"
										minW={header.id === 'acciones' ? '100px' : undefined}
										width={header.id === 'acciones' ? '100px' : undefined}
									>
										<Flex
											justifyContent="space-between"
											align="center"
											fontSize={{ sm: '10px', lg: '14px' }}
											color="gray.400"
										>
											{flexRender(header.column.columnDef.header, header.getContext())}
										</Flex>
									</Th>
								))}
								<Th minW="100px" width="100px" fontSize={{ sm: '10px', lg: '14px' }} color="gray.400">
									Acciones
								</Th>
							</Tr>
						))}
					</Thead>
					<Tbody>
						{table.getRowModel().rows.map((row) => (
							<Tr
								key={row.id}
								_hover={{ bg: useColorModeValue('gray.100', 'whiteAlpha.100'), cursor: 'pointer' }}
							>
								{row.getVisibleCells().map((cell) => (
									<Td
										key={cell.id}
										fontSize={{ sm: '14px' }}
										minW={{ sm: '170px', md: '200px', lg: 'auto' }}
										borderColor={borderColor}
										mt="20px !important"
										py="22px !important"
										width={cell.column.id === 'acciones' ? '100px' : undefined}
									>
										{flexRender(cell.column.columnDef.cell, cell.getContext())}
									</Td>
								))}
								<Td minW="100px" width="100px">
									<Button
										size="sm"
										colorScheme="red"
										variant="outline"
										onClick={async () => {
											if (isReadOnly) {
												setActiveToUnassign(row.original);
												onConfirmOpen();
											} else {
												handleDeleteItem(row.original);
											}
										}}
									>
										{isReadOnly ? 'Desasignar' : 'Eliminar'}
									</Button>

									<Modal isOpen={isConfirmOpen} onClose={onConfirmClose} isCentered>
										<ModalOverlay />
										<ModalContent>
											<ModalHeader>Confirmar Desasignación</ModalHeader>
											<ModalCloseButton />
											<ModalBody>
												<Alert status="warning" mb={4} borderRadius="md">
													<AlertIcon />
													¿Está seguro que quiere desasignar este activo?
												</Alert>
												<Box bg="gray.100" p={3} borderRadius="md">
													<Text fontWeight="bold">{activeToUnassign?.item[0]}</Text>
													<Text fontSize="sm">{activeToUnassign?.item[1]}</Text>
												</Box>
												<Text mt={4}>
													Se creará un nuevo resguardo con el activo sobrante.
												</Text>
											</ModalBody>
											<ModalFooter>
												<Button variant="outline" mr={3} onClick={onConfirmClose}>
													Cancelar
												</Button>
												<Button
													colorScheme="red"
													onClick={async () => {
														if (!activeToUnassign) return;

														try {
															const url = `https://inventariosbackend.velasresorts.com/inventarios/activos/editar/${activeToUnassign.idActivo}`;
															const response = await fetch(url, {
																method: 'PUT',
																headers: {
																	'Content-Type': 'application/json',
																},
																body: JSON.stringify({
																	EstadosId: "1",
																}),
															});

															if (!response.ok) {
																throw new Error('Error al desasignar activo');
															}

															const result = await response.json();
															console.log('Respuesta al desasignar:', result);

															handleDeleteItem(activeToUnassign);
															onConfirmClose();

															toast({
																title: 'Activo desasignado',
																description: 'El activo ha sido desasignado correctamente.',
																status: 'success',
																duration: 3000,
																isClosable: true,
															});
														} catch (error) {
															console.error('Error en la solicitud de desasignar:', error);
															toast({
																title: 'Error al desasignar',
																description: 'Ocurrió un error al intentar desasignar el activo.',
																status: 'error',
																duration: 3000,
																isClosable: true,
															});
														}
													}}
												>
													Confirmar Desasignación
												</Button>
											</ModalFooter>
										</ModalContent>
									</Modal>
								</Td>
							</Tr>
						))}
					</Tbody>
				</Table>
			</Box>
		</Flex>
	);
}